<template>
  <div class="preview-wrapper">
    <div class="label-object-set-preview">
      <img v-if="files.length > 0" :src="`${fileUrl(files[file_idx].id, setId, img_type)}&cvt=thumb_large`" ref="img"
        @load="imgLoaded">
      <svg v-if="files.length > 0" :viewBox="`0 0 ${size.width} ${size.height}`">
        <g v-for="(lo, loi) in labelObjectsWithPoly" :key="lo.id" class="lo">
          <path v-for="(pg, pgi) in lo.polygons" :key="`lo.id-${pgi}`" :fill="getColor(lo, loi)"
            :d="pointsString(pg)" />
        </g>
      </svg>
    </div>
    <div class="option_btn">
      <slot></slot>
    </div>
    <a v-if="files.length > 0" href="" class="download_btn" @click.prevent=""
      @click="download_image(files[file_idx], setId)"><i class="mx-1 fa fa-download fa-lg" /></a>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'LOSPreviewSvg',
  data() {
    return {
      imgSize: null,
    };
  },
  props: {
    info: { type: Object, default: null },
    img_type: { type: String, default: 'sample' },
    file_idx: {type: String, default: '0'}
  },
  components: {
  },
  computed: {
    size() {
      const f = this.files[this.file_idx];
      if (f.meta && f.meta.resolution) {
        return f.meta.resolution;
      }
      return this.imgSize || { width: 1000, height: 1000 };
    },
    ...mapGetters('Auth', ['fileUrl']),
    files() {
      if(!this.info)
        return [];
      if(this.img_type == 'sample')
        return this.info.files;
      else
        return this.info.detection_files;
    },
    setId() {
      if(!this.info)
        return null;
      if(this.img_type == 'sample')
        return this.info.sample_set_id;
      else
        return this.info.detection_set_id;
    },
    ...mapState('Auth', ['activeProjectId', 'token']),
    ...mapGetters('Project', ['currentProjectTags']),
    firstLabelObjectSet() { return this.info.label_object_sets[0] || {}; },
    tagColors() {
      return this.currentProjectTags.reduce((currentProjectTags, t) => ({ ...currentProjectTags, [t.tag.id]: t }), {});
    },
    labelObjects() {
      return this.info && this.info.label_object_set
        && this.firstLabelObjectSet.label_objects ? this.firstLabelObjectSet.label_objects : [];
    },
    labelObjectsWithPoly() {
      const labelObjects = this.labelObjects
        .filter((lo) => {
          if ((this.files.length > 0) && ((lo.file_id === this.files[this.file_idx]?.id) || (lo.file_id === null))) {
            return true;
          }

          return false;
        })
        .map((lo) => {
          try { lo.configO = JSON.parse(lo.config); } catch { lo.configO = {}; }
          lo.polygons = lo.configO.polygons || [];
          return lo;
        });
      return labelObjects;
    },
  },
  watch: {
  },

  mounted() {
  },

  methods: {
    pointsString(polygons) {
      return polygons.map((points) => points.map((point, idx) => `${idx > 0 ? 'L' : 'M'} ${Math.round(point[0])} ${Math.round(point[1])}`).join(' ')).join(' ');
    },
    imgLoaded() {
      this.imgSize = {
        width: this.$refs.img.naturalWidth,
        height: this.$refs.img.naturalHeight,
      };
    },

    getColor(lo, idx) {
      const colors = [
        '#FF6633', '#FFFF99', '#3366E6', '#B34D4D', '#E6B3B3',
        '#FF99E6', '#E6331A', '#B366CC', '#CC80CC', '#E666FF',
        '#E666B3', '#B3B31A', '#809980', '#999933', '#66E64D',
        '#E64D66', '#99E6E6',
      ];
      let color = null;
      if (lo.tags.length === 1 && lo.tags[0] in this.tagColors) {
        color = this.tagColors[lo.tags[0]].color;
      } else if (lo.configO?.color) {
        color = lo.configO.color;
      } else if (idx < colors.length) {
        color = colors[idx];
      } else {
        color = '#5050aa';
      }
      return color;
    },

    download_image(file, setId) {
      const name = `ss${setId}_s${file.sample_id}_f${file.id}`;

      fetch(this.fileUrl(file.id, setId, this.img_type), {
        mode: 'no-cors',
      })
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.download = name;
          a.href = blobUrl;
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    },
  }
};
</script>

<style lang=scss scoped>
.label-object-set-preview {
  max-width: 300px;
  max-height: 300px;
  position: relative;
  /* <= shrinks container to image size */
  // transition: transform 150ms ease-in-out;
}

.label-object-set-preview img {
  /* <= optional, for responsiveness */
  display: block;
  max-width: 100%;
  max-height: 300px;
  height: auto;
}

.label-object-set-preview svg {
  position: absolute;
  top: 0;
  left: 0;
}

.label-object-set-preview svg path {
  fill-opacity: 0.3;

}

.preview-wrapper:hover svg path {
  fill-opacity: 0.7;
}

// .label-object-set-preview:hover {
//   transform: rotate( 15deg );
// }

.preview-wrapper:hover .download_btn {
  display: block;
}

.preview-wrapper .download_btn {
  position: absolute;
  bottom: 2px;
  right: 2px;
  display: none;
}

.download_btn {
  background-color: rgba(200, 200, 200, 0.7);
  padding: 1px 0 0 0;
  border-radius: 5px;
}

.preview-wrapper:hover .option_btn {
  display: block;
}

.option_btn {
  position: absolute;
  display: none;
  bottom: 2px;
  left: 6px;
}

.preview-wrapper {
  display: flex;
  align-items: center;
  aspect-ratio: 1;
}
</style>
